class PlayVideo extends HTMLElement {
    constructor() {
        super();

        const video = this.querySelector('video');
        video.addEventListener('click', (e) => {
            var thisVid = e.target;
            if (thisVid.paused) {
                thisVid.parentNode.classList.add('played')
                thisVid.play();
                let sliderSiblings = getSiblings(thisVid.closest('.swiper-slide'));
                sliderSiblings.forEach((slide) => {
                    let otherVid = slide.querySelector('.played video');
                    if (otherVid) {
                        otherVid.parentNode.classList.remove('played');
                        otherVid.pause();
                    }
                });
            } else {
                thisVid.parentNode.classList.remove('played')
                video.pause()
            }
        });

        let getSiblings = function(e) {
            let siblings = [];
            // if no parent, return no sibling
            if(!e.parentNode) {
                return siblings;
            }
            // first child of the parent node
            let sibling  = e.parentNode.firstChild;
            // collecting siblings
            while (sibling) {
                if (sibling.nodeType === 1 && sibling !== e) {
                    siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
            }
            return siblings;
        }

        video.addEventListener('ended' , () => {
            video.parentNode.classList.remove('played')
            video.pause()
        });
    }
}

customElements.define('play-video', PlayVideo);